var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.335mm",
    height: "16.537mm",
    viewBox: "0 0 15.335 16.537",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m253.28 55.218h43.47v46.878h-43.47z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.747 -97.478)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -77.604 133.5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.73 92.87c-8.4886-2.4034-12.651-12.222-8.4067-19.968 4.1819-7.8337 14.9-10.244 21.632-4.1715 0.5897 0.52274 1.1221 1.0983 1.5985 1.7141l-0.074-0.0163-0.261 0.6342c-0.2513-0.30674-0.5153-0.60337-0.7939-0.88636-7.2475-7.5018-19.88-4.94-22.714 5.3674-1.6522 6.0321 1.2551 12.701 6.8527 15.507 5.0199 2.6394 11.158 1.6754 15.237-1.814l0.2787 0.21176c-3.415 3.3324-8.4106 4.8574-13.349 3.4224",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.31 72.581c-1.393-3.8573-3.8548-7.3412-7.1518-9.9181-13.807-10.798-33.783-2.5481-35.21 15.107-1.0095 13.584 10.567 24.767 24.098 23.35 5.2217-0.5091 10.088-2.9409 13.653-6.6392l0.2378 0.18057c-5.4983 6.1024-14.165 9.0257-22.541 6.5597-13.52-3.8301-20.173-19.443-13.508-31.824 4.7899-9.2103 15.929-14.172 25.954-11.307 7.4054 2.0103 12.76 7.7357 14.902 14.586z",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.33 93.774c-6.6679-5.308-8.6424-14.89-4.5633-22.374 5.3607-10.13 19.147-13.115 27.81-5.3302 1.7401 1.5344 3.1097 3.4189 4.0832 5.4921l-0.6457-0.14123c-1.1428-2.0483-2.6915-3.8821-4.5727-5.349-11.064-8.638-27.033-2.111-28.143 12.066-0.7735 10.853 8.4581 19.755 19.266 18.647 4.03-0.38382 7.8063-2.1906 10.638-4.9634l0.2597 0.1974c-6.0572 6.4933-16.415 7.92-24.132 1.7548",
    fill: "#4993c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.42 79.466c0-2.7094-2.1964-4.906-4.9059-4.906-2.7094 0-4.906 2.1966-4.906 4.906 0 2.7096 2.1966 4.906 4.906 4.906 2.7095 0 4.9059-2.1964 4.9059-4.906",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.12 90.506-1.3936 2.4138 1.3936 2.414h2.7874l1.3939-2.414-1.3939-2.4138z",
    fill: "#e95329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.19 55.218-2.4624 4.2654 2.4624 4.265h4.9253l2.4627-4.265-2.4627-4.2654z",
    fill: "#a72f62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.7 80.885 2.414 1.3937 2.4138-1.3937v-2.7874l-2.4138-1.3937-2.414 1.3937z",
    fill: "#1e6eac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.98 73.441 2.6924-0.72138 0.7214-2.6924-1.9708-1.971-2.6924 0.72139-0.7216 2.6924z",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.24 98.935 5.5409-1.4846 1.4844-5.541-4.0562-4.0561-5.5406 1.4849-1.4848 5.5405z",
    fill: "#fbbc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.09 96.987 0.1114 2.7852 2.4677 1.2961 2.3562-1.489-0.1114-2.785-2.4677-1.2962z",
    fill: "#99c22e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.77 65.261 1.8096 5.2935 5.4891 1.0797 3.6796-4.2138-1.8096-5.2939-5.489-1.0793z",
    fill: "#009149"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.00461a703a799f5e97ba1a3948a287b6.svg";
export { ForwardRef as ReactComponent };